import { render, staticRenderFns } from "./calc.vue?vue&type=template&id=31b3a674&"
import script from "./calc.vue?vue&type=script&lang=js&"
export * from "./calc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BetslipResults: require('/var/web/bet777.es/components/betslip/results.vue').default,UiBetslipTabs: require('/var/web/bet777.es/themes/dark/ui/Betslip/Tabs.vue').default,BetslipLine: require('/var/web/bet777.es/components/betslip/line.vue').default,UiBetslipSeguroCombinadaNotice: require('/var/web/bet777.es/themes/dark/ui/Betslip/SeguroCombinadaNotice.vue').default,UiBetslipComboBoostNotice: require('/var/web/bet777.es/themes/dark/ui/Betslip/ComboBoostNotice.vue').default,UiBetslipEmpty: require('/var/web/bet777.es/themes/dark/ui/Betslip/Empty.vue').default,UiBetslipSystems: require('/var/web/bet777.es/themes/dark/ui/Betslip/Systems.vue').default,UiBetslipComboBoostBanner: require('/var/web/bet777.es/themes/dark/ui/Betslip/ComboBoostBanner.vue').default,BetslipMoney: require('/var/web/bet777.es/components/betslip/money.vue').default,UiBetslipBetType: require('/var/web/bet777.es/themes/dark/ui/Betslip/BetType.vue').default,UiBetslipFreeBet: require('/var/web/bet777.es/themes/dark/ui/Betslip/FreeBet.vue').default,UiBetslipButton: require('/var/web/bet777.es/themes/dark/ui/Betslip/Button.vue').default,UiBetslipWrapper: require('/var/web/bet777.es/themes/dark/ui/Betslip/Wrapper.vue').default})
